export default "__VITE_ASSET__4320f956__"